import { useEffect, useState } from "react";
import Popup1 from "../../../components/UI/Talent/Media/popup1";
import Popup2 from "../../../components/UI/Talent/Media/popup2";
import Popup3 from "../../../components/UI/Talent/Media/popup3";
import VerificationGate from "../../../components/UI/Talent/VerificationGate/VerificationGate";
import classes from "./media.module.css";
import Loop2 from "../../../assets/loader/loop2.svg";
import { errorHandler } from "../../../utils";
import { talentProfile } from "../../../services/talentCalls";
import FullScreenLoader from "../../../components/Loaders/FullScreen/loader";

const TalentMedia = () => {
  const [data, setData] = useState(null);
  const [load, setLoad] = useState(true);
  const fetchProfile = async () => {
    try {
      const res = await talentProfile();
      if (res?.data.data.talent) {
        setData(res?.data.data.talent);
      }
      setLoad(false);
    } catch (error) {
      setLoad(false);
      error.response?.data
        ? errorHandler(error.response?.data?.errors, "Error")
        : errorHandler(
            "Network error: Something went wrong, Please check your internet connection and try again.",
            "Error"
          );
    }
  };

  useEffect(() => {
    fetchProfile();
  }, []);

  if (load) {
    return <FullScreenLoader />;
  }

  const pageContent = (
    <div className={classes.main}>
      <div className={`flex ${classes.parentDiv}`}>
        <Popup1 data={data} Loop2={Loop2} setData={setData} />
        <div>
          <Popup2 data={data} Loop2={Loop2} setData={setData} />
          <Popup3 data={data} setData={setData} />
        </div>
      </div>
    </div>
  );

  if (data && !data?.profileVerified) {
    return <VerificationGate>{pageContent}</VerificationGate>;
  }

  return pageContent;
};

export default TalentMedia;
